import { DownloadRounded } from "@mui/icons-material";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { useSnackbar } from "notistack";
import { usePostHog } from "posthog-js/react";
import { DOWNLOAD_ENTITY } from "../../../../../utils/posthogEvents";

function DownloadEntity({ answer }) {
  const posthog = usePostHog();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const { content_object } = answer;
  const entity = content_object["entity"];

  const handleDownload = async () => {
    try {
      const url = entity && entity["entity_url"];
      if (!url) return;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Failed to download. Status: ${response.status}`);
      }

      const blob = await response.blob();
      const filename = entity["title"] || "entity";
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
      posthog.capture(DOWNLOAD_ENTITY);
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Failed to download entity", { variant: "error" });
    }
  };
  return (
    <Tooltip title="Download Entity">
      <IconButton
        size="small"
        sx={{ color: theme.palette.action.active, ml: 1 }}
        onClick={handleDownload}>
        <DownloadRounded sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}

export default DownloadEntity;
